import { render } from "./PhysicianFilter.vue?vue&type=template&id=4290856a"
const script = {}

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/navbarFilter/PhysicianFilter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4290856a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4290856a', __exports__)) {
    console.log('reload')
    api.reload('4290856a', __exports__)
  }
  
  module.hot.accept("./PhysicianFilter.vue?vue&type=template&id=4290856a", () => {
    console.log('re-render')
    api.rerender('4290856a', render)
  })

}


export default __exports__